/*
	CartApi — single source of truth for cart HTTP calls.
	Wraps window.routes.* and consistently appends the `.js` suffix.
	Methods return a raw `fetch` Response unless noted, so callers keep control
	over `.json()` / `.text()` / `.ok` handling. CartApi.get() is the exception —
	it returns the parsed cart JSON directly since that is always what callers want.
*/
(function () {
	"use strict";

	function routes() {
		return (typeof window !== "undefined" && window.routes) || {};
	}

	function cartUrl() {
		return routes().cart_url || "/cart";
	}
	function addUrl() {
		return routes().cart_add_url || "/cart/add";
	}
	function changeUrl() {
		return routes().cart_change_url || "/cart/change";
	}
	function updateUrl() {
		return routes().cart_update_url || "/cart/update";
	}

	function jsonHeaders(extra) {
		var headers = {
			"Content-Type": "application/json",
			Accept: "application/json",
		};
		if (extra) {
			for (var k in extra) if (Object.prototype.hasOwnProperty.call(extra, k)) headers[k] = extra[k];
		}
		return headers;
	}

	function serializeBody(body) {
		if (body == null) return undefined;
		if (typeof body === "string") return body;
		if (typeof FormData !== "undefined" && body instanceof FormData) return body;
		return JSON.stringify(body);
	}

	function postJson(url, body, options) {
		options = options || {};
		var init = {
			method: "POST",
			headers: jsonHeaders(options.headers),
			body: serializeBody(body),
		};
		if (options.signal) init.signal = options.signal;
		return fetch(url, init);
	}

	function postForm(url, formData, options) {
		options = options || {};
		var headers = {
			Accept: "application/json",
			"X-Requested-With": "XMLHttpRequest",
		};
		if (options.headers) {
			for (var k in options.headers) if (Object.prototype.hasOwnProperty.call(options.headers, k)) headers[k] = options.headers[k];
		}
		var init = {
			method: "POST",
			headers: headers,
			body: formData,
		};
		if (options.signal) init.signal = options.signal;
		return fetch(url, init);
	}

	var CartApi = {
		get: function () {
			return fetch(cartUrl() + ".js").then(function (r) {
				return r.json();
			});
		},

		add: function (body, options) {
			if (typeof FormData !== "undefined" && body instanceof FormData) {
				return postForm(addUrl() + ".js", body, options);
			}
			return postJson(addUrl() + ".js", body, options);
		},

		change: function (body, options) {
			return postJson(changeUrl() + ".js", body, options);
		},

		update: function (body, options) {
			return postJson(updateUrl() + ".js", body, options);
		},

		/** Fetch the cart HTML for a given Shopify section id (e.g. `cart-drawer`, `main-cart-items`). Returns a text promise. */
		fetchSectionHtml: function (sectionId) {
			return fetch(cartUrl() + "?section_id=" + encodeURIComponent(sectionId)).then(function (r) {
				return r.text();
			});
		},

		/** Fetch the cart HTML for a given alternate view (e.g. `drawer`). Returns a text promise. */
		fetchView: function (view) {
			return fetch(cartUrl() + "?view=" + encodeURIComponent(view)).then(function (r) {
				return r.text();
			});
		},

		/** Parse an HTML string into a document (or a selected element). */
		parseSection: function (html, selector) {
			var doc = new DOMParser().parseFromString(html, "text/html");
			return selector ? doc.querySelector(selector) : doc;
		},

		routes: {
			cartUrl: cartUrl,
			addUrl: addUrl,
			changeUrl: changeUrl,
			updateUrl: updateUrl,
		},
	};

	if (typeof window !== "undefined") {
		window.CartApi = CartApi;
	}
})();
